"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createEqualWeights: function() {
        return createEqualWeights;
    },
    createRumble: function() {
        return createRumble;
    },
    deleteRumble: function() {
        return deleteRumble;
    },
    duplicateRumble: function() {
        return duplicateRumble;
    },
    generateRumbles: function() {
        return generateRumbles;
    },
    randomBool: function() {
        return randomBool;
    },
    resetRumbles: function() {
        return resetRumbles;
    },
    rumbleComplete: function() {
        return rumbleComplete;
    },
    rumbleEliminate: function() {
        return rumbleEliminate;
    },
    rumbleEnter: function() {
        return rumbleEnter;
    },
    selectRandomItem: function() {
        return selectRandomItem;
    },
    updateRumble: function() {
        return updateRumble;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
const _weighted = /*#__PURE__*/ _interop_require_default(require("weighted"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createRumble(payload) {
    return {
        type: _types.ADD_RUMBLE,
        payload
    };
}
const randomBool = ()=>Math.random() >= 0.5;
const createEqualWeights = (length)=>new Array(length).fill(1 / length);
const selectRandomItem = (items)=>_weighted.default.select(items, createEqualWeights(items.length));
function rumbleEliminate({ id }) {
    return {
        type: _types.RUMBLE_ELIMINATE,
        payload: {
            id
        }
    };
}
function rumbleComplete({ id }) {
    return {
        type: _types.RUMBLE_COMPLETE,
        payload: {
            id
        }
    };
}
function rumbleEnter({ id, wrestlerId }) {
    return {
        type: _types.RUMBLE_ENTER,
        payload: {
            id,
            wrestlerId
        }
    };
}
function duplicateRumble(payload) {
    return {
        type: _types.DUPLICATE_RUMBLE,
        payload
    };
}
function updateRumble(payload) {
    return {
        type: _types.UPDATE_RUMBLE,
        payload
    };
}
function deleteRumble(id) {
    return {
        type: _types.DELETE_RUMBLE,
        payload: id
    };
}
function resetRumbles() {
    return {
        type: _types.RESET_RUMBLES
    };
}
function generateRumbles(payload) {
    return {
        type: _types.GENERATE_RUMBLES,
        payload
    };
}
